<template>
  <div class="">
    <b-table
      :items="data"
      :fields="fields"
      striped
      class="bg-light"
      responsive="sm"
    >
      <template #cell(idx)="data">
        {{ data.index + 1 }}
      </template>

      <template #cell(details)="row">
        <b-button
          :variant="row.detailsShowing ? 'info' : 'primary'"
          size="sm"
          @click="row.toggleDetails"
          class="mr-2"
        >
          {{ row.detailsShowing ? "Hide" : "Show" }} {{ row.field.label }}
        </b-button>
      </template>

      <template #cell(offer-codecs)="row">
        <slot name="offer-codecs" v-bind="row" />
      </template>
      <template #cell(ips)="row">
        <slot name="ips" v-bind="row" />
      </template>

      <template #row-details="row">
        <slot name="details" v-bind="row" />
      </template>
      <template #cell(actions)="row">
        <slot name="actions" v-bind="row" />
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  props: {
    fields: Array,
    data: Array,
  },
};
</script>

<style></style>
